import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, INoticeProps, Grid, GridColumn, TextField, Button, Notice, Text } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import BlacklistStore from '../stores/BlacklistStore';

const FORM_ID: string = 'blacklistForm';

interface BlacklistProps {
  blacklistStore?: BlacklistStore;
}

@observer
class Blacklist extends React.Component<BlacklistProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  @observable accessor value: string = '';
  @observable accessor clicked: boolean = false;

  private getNoticeFromApiResult(): INoticeProps {
    const translate = this.context.translate;
    const {
      blacklistStore: { blacklistResult }
    } = this.props;

    switch (blacklistResult.imeiState) {
      case 'BLACKLISTED':
        return {
          type: 'error',
          children: translate('blacklist.resultNotice.blacklisted')
        };
      case 'NOT_BLACKLISTED':
        return {
          type: 'success',
          children: translate('blacklist.resultNotice.notBlacklisted')
        };
      case 'INVALID':
        return {
          type: 'error',
          children: translate('blacklist.resultNotice.invalid')
        };
      default:
        return null;
    }
  }

  private getNotice(): INoticeProps {
    const translate = this.context.translate;
    const {
      blacklistStore: { blacklistResult }
    } = this.props;
    switch (blacklistResult.status) {
      case 'UNINITIALIZED':
      case 'FETCHING':
        return null;
      case 'FETCHED':
        return this.getNoticeFromApiResult();
      case 'ERROR':
      default:
        return {
          type: 'error',
          children: translate('general.error.message')
        };
    }
  }

  private onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!this.clicked) {
      this.clicked = true;
      this.props.blacklistStore.validateAndCheckImei(this.value).then(() => {
        this.clicked = false;
      });
    }
  };

  private onChange = (value: string) => {
    this.value = value;
  };

  get isLoading() {
    return this.props.blacklistStore.blacklistResult.status === 'FETCHING';
  }

  public render() {
    const translate = this.context.translate;
    const noticeProps = this.getNotice();

    return (
      <AnalyticsTrigger trigger={{ id: `Submit - ${FORM_ID}`, callback: 'onSubmit' }}>
        <form onSubmit={this.onSubmit} id={FORM_ID}>
          <Text>
            <Grid align={['bottom-xs']}>
              <GridColumn width={['lg-4', 'md-5', 'sm-7']}>
                <TextField
                  id="blacklistTextField"
                  label={translate('blacklist.textField.label')}
                  value={this.value}
                  onChange={this.onChange}
                  isDisabled={this.isLoading || this.clicked}
                />
              </GridColumn>
              <GridColumn width={['sm']}>
                <Button
                  text={translate('blacklist.submitButton.text')}
                  isLoading={this.isLoading}
                  disabled={this.isLoading || this.clicked}
                  attributes={{ type: 'submit' }}
                />
              </GridColumn>
            </Grid>
            {noticeProps && <Notice {...noticeProps} />}
          </Text>
        </form>
      </AnalyticsTrigger>
    );
  }
}

export default inject('blacklistStore')(Blacklist);
